import clsx from 'clsx';

interface ReelsProps {
  className?: string;
}

const Reels: React.FC<ReelsProps> = ({ className }) => {
  return (
    <svg
      className={clsx('reels', className)}
      fill="none"
      height="165"
      viewBox="0 0 100 165"
      width="100"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill="white" height="164" rx="7.5" width="99" x="0.5" y="0.5" />
      <rect height="164" rx="7.5" stroke="#D1D2D4" width="99" x="0.5" y="0.5" />
      <rect fill="url(#paint0_linear_13416_25790)" height="149" width="84" x="8" y="8" />
      <g clipPath="url(#clip0_13416_25790)">
        <path
          d="M54.3839 71.3632H45.589C41.4773 71.3632 38.1319 74.7086 38.1319 78.8205V87.1528C38.1319 91.2645 41.4773 94.6099 45.589 94.6099H54.3839C58.4958 94.6097 61.8412 91.2645 61.8412 87.1525V78.8205C61.8412 74.7086 58.4958 71.3632 54.3839 71.3632ZM59.6284 77.7668H56.0072L53.6167 73.4707H54.3839C56.9729 73.4707 59.1376 75.32 59.6284 77.7668ZM48.6399 77.7668L46.2497 73.4707H51.2052L53.5954 77.7665L48.6399 77.7668ZM43.9765 73.7201L46.2278 77.7665H40.3447C40.7291 75.8508 42.1395 74.3023 43.9765 73.7201ZM54.3839 92.5022H45.589C42.6393 92.5022 40.2394 90.1025 40.2394 87.1525V79.8743H59.7337V87.1528C59.7337 90.1025 57.3338 92.5022 54.3839 92.5022Z"
          fill="#D9D9D9"
        />
        <path
          d="M54.3839 71.3632H45.589C41.4773 71.3632 38.1319 74.7086 38.1319 78.8205V87.1528C38.1319 91.2645 41.4773 94.6099 45.589 94.6099H54.3839C58.4958 94.6097 61.8412 91.2645 61.8412 87.1525V78.8205C61.8412 74.7086 58.4958 71.3632 54.3839 71.3632ZM59.6284 77.7668H56.0072L53.6167 73.4707H54.3839C56.9729 73.4707 59.1376 75.32 59.6284 77.7668ZM48.6399 77.7668L46.2497 73.4707H51.2052L53.5954 77.7665L48.6399 77.7668ZM43.9765 73.7201L46.2278 77.7665H40.3447C40.7291 75.8508 42.1395 74.3023 43.9765 73.7201ZM54.3839 92.5022H45.589C42.6393 92.5022 40.2394 90.1025 40.2394 87.1525V79.8743H59.7337V87.1528C59.7337 90.1025 57.3338 92.5022 54.3839 92.5022Z"
          fill="url(#paint1_radial_13416_25790)"
        />
        <path
          d="M54.3839 71.3632H45.589C41.4773 71.3632 38.1319 74.7086 38.1319 78.8205V87.1528C38.1319 91.2645 41.4773 94.6099 45.589 94.6099H54.3839C58.4958 94.6097 61.8412 91.2645 61.8412 87.1525V78.8205C61.8412 74.7086 58.4958 71.3632 54.3839 71.3632ZM59.6284 77.7668H56.0072L53.6167 73.4707H54.3839C56.9729 73.4707 59.1376 75.32 59.6284 77.7668ZM48.6399 77.7668L46.2497 73.4707H51.2052L53.5954 77.7665L48.6399 77.7668ZM43.9765 73.7201L46.2278 77.7665H40.3447C40.7291 75.8508 42.1395 74.3023 43.9765 73.7201ZM54.3839 92.5022H45.589C42.6393 92.5022 40.2394 90.1025 40.2394 87.1525V79.8743H59.7337V87.1528C59.7337 90.1025 57.3338 92.5022 54.3839 92.5022Z"
          fill="url(#paint2_radial_13416_25790)"
        />
        <path
          d="M52.981 84.8227L48.3946 82.3714C47.7713 82.0382 47.0176 82.49 47.0176 83.1968V88.0996C47.0176 88.8064 47.7713 89.2582 48.3946 88.925L52.981 86.4737C53.6407 86.1209 53.6407 85.1755 52.981 84.8227Z"
          fill="#D9D9D9"
        />
        <path
          d="M52.981 84.8227L48.3946 82.3714C47.7713 82.0382 47.0176 82.49 47.0176 83.1968V88.0996C47.0176 88.8064 47.7713 89.2582 48.3946 88.925L52.981 86.4737C53.6407 86.1209 53.6407 85.1755 52.981 84.8227Z"
          fill="url(#paint3_radial_13416_25790)"
        />
        <path
          d="M52.981 84.8227L48.3946 82.3714C47.7713 82.0382 47.0176 82.49 47.0176 83.1968V88.0996C47.0176 88.8064 47.7713 89.2582 48.3946 88.925L52.981 86.4737C53.6407 86.1209 53.6407 85.1755 52.981 84.8227Z"
          fill="url(#paint4_radial_13416_25790)"
        />
      </g>
      <path d="M34 8H66C66 10.2091 64.2091 12 62 12H38C35.7909 12 34 10.2091 34 8Z" fill="white" />
      <rect fill="#EDEDEE" height="2" rx="1" width="10" x="43" y="8" />
      <rect fill="#EDEDEE" height="2" rx="1" width="2" x="55" y="8" />
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="paint0_linear_13416_25790" x1="50" x2="50" y1="8" y2="157">
          <stop stopColor="#EDE8F9" />
          <stop offset="1" stopColor="#FFF8EF" />
        </linearGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="translate(34.1604 73.0378) rotate(78.4614) scale(10.3066 43.2628)"
          gradientUnits="userSpaceOnUse"
          id="paint1_radial_13416_25790"
          r="1"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="translate(44.4297 96.4004) rotate(-90) scale(23.0393 21.8547)"
          gradientUnits="userSpaceOnUse"
          id="paint2_radial_13416_25790"
          r="1"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="translate(34.1604 73.0378) rotate(78.4614) scale(10.3066 43.2628)"
          gradientUnits="userSpaceOnUse"
          id="paint3_radial_13416_25790"
          r="1"
        >
          <stop stopColor="#3771C8" />
          <stop offset="0.128" stopColor="#3771C8" />
          <stop offset="1" stopColor="#6600FF" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          cx="0"
          cy="0"
          gradientTransform="translate(44.4297 96.4004) rotate(-90) scale(23.0393 21.8547)"
          gradientUnits="userSpaceOnUse"
          id="paint4_radial_13416_25790"
          r="1"
        >
          <stop stopColor="#FFDD55" />
          <stop offset="0.1" stopColor="#FFDD55" />
          <stop offset="0.5" stopColor="#FF543E" />
          <stop offset="1" stopColor="#C837AB" />
        </radialGradient>
        <clipPath id="clip0_13416_25790">
          <rect fill="white" height="24" transform="translate(38 71)" width="24" />
        </clipPath>
      </defs>
    </svg>
  );
};


export default Reels;
